import { utils } from '../utils/index';
import {
  SET_WIX_DATA,
  SET_ITEMS,
  SET_RENDERED_ITEMS_COUNT,
  VIDEO_PLAY_MODE,
  GALLERY_WINDOW_LAYOUT_CHANGED,
  VIDEO_ENDED,
  VIDEO_ADDED,
  NAVIGATION_IN,
  EDITOR_MODE_CHANGED,
} from '../constants/galleryTypes.js'

export function initWixData() {
    if (utils.isInWix() && !utils.isDemo()) {
        return function (dispatch) {
            Wix.getBoundingRectAndOffsets((res) => {
              dispatch({
                  type: SET_WIX_DATA,
                  boundingRectAndOffsets: res
              })
            });
        }
    } else {
        return {
            type: SET_WIX_DATA
        }
    }
}


// export function setItems(items) {
//     return {
//         items: items,
//         type: SET_ITEMS
//     }
// }
//
//
// export function setRenderedItemsCount(count) {
//     return {
//         count: count,
//         type: SET_RENDERED_ITEMS_COUNT
//     }
// }

export function navigationIn() {
  return {
    videoIndexAutoPlay: utils.isEditor() ? -1 : window.videoQueue.next(),
    type: NAVIGATION_IN
  }
}

export function videoPlayModeChanged(videoPlayMode) {
  return {
    videoPlayMode,
    type: VIDEO_PLAY_MODE
  }
}

export function videoEnded(idx) {
  return {
    videoIndexAutoPlay: window.videoQueue.next(),
    type: VIDEO_ENDED
  }
}

export function videoAdded(idx) {
  return {
    videoIndexAutoPlay: idx,
    type: VIDEO_ADDED
  }
}

export function galleryWindowLayoutChanged({documentHeight}) {
  const q = window.videoQueue;
  const nextIdx = q.isCurrentVideoVisible() ? q.current() : q.next();
  return {
    documentHeight,
    videoIndexAutoPlay: nextIdx,
    type: GALLERY_WINDOW_LAYOUT_CHANGED
  };
}

export function editorModeChanged() {
  const q = window.videoQueue;
  const nextIdx = utils.isEditor() ? -1 :
    q.isCurrentVideoVisible() ? q.current() : q.next();
  return {
    videoIndexAutoPlay: nextIdx,
    type: EDITOR_MODE_CHANGED
  };
}



// WEBPACK FOOTER //
// ./actions/galleryActions.js